import { render, staticRenderFns } from "./WebPlayerStream.vue?vue&type=template&id=8aa10a3a&"
import script from "./WebPlayerStream.vue?vue&type=script&lang=js&"
export * from "./WebPlayerStream.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8aa10a3a')) {
      api.createRecord('8aa10a3a', component.options)
    } else {
      api.reload('8aa10a3a', component.options)
    }
    module.hot.accept("./WebPlayerStream.vue?vue&type=template&id=8aa10a3a&", function () {
      api.rerender('8aa10a3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/lib/components/WebPlayerStream.vue"
export default component.exports